var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99174 19H2.61608C1.17514 19 0 17.8316 0 16.399V7.33038C0 5.89775 1.17514 4.7294 2.61608 4.7294H3.99174C5.43268 4.7294 6.60781 5.89775 6.60781 7.33038V16.399C6.60781 17.8316 5.43268 19 3.99174 19ZM2.61608 6.11566C1.94457 6.11566 1.39897 6.65811 1.39897 7.32574V16.3944C1.39897 17.062 1.94457 17.6045 2.61608 17.6045H3.99174C4.66324 17.6045 5.20884 17.062 5.20884 16.3944V7.32574C5.20884 6.65811 4.66324 6.11566 3.99174 6.11566H2.61608Z",
    className: "fill-selector",
    fill: "#48C44D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4426 17.7436H5.91299V16.3527H16.4426C16.5405 16.3527 16.6291 16.2831 16.6524 16.1858L18.6017 6.7462C18.6297 6.60247 18.569 6.50048 18.5271 6.44948C18.4851 6.39848 18.3965 6.31966 18.2473 6.31966H14.6006C14.3628 6.31966 14.139 6.21766 13.9851 6.03684C13.8312 5.85603 13.7659 5.61957 13.8032 5.38776L14.2555 2.69869C14.3768 1.72506 13.5934 1.4747 13.2483 1.41443C12.6514 1.30779 11.9379 1.51179 11.7933 2.10988L11.7514 2.23042C10.4783 5.10494 8.58037 6.92702 6.10418 7.64565L5.71247 6.31039C7.75963 5.71694 9.3498 4.17304 10.4503 1.72043C10.8234 0.343439 12.2876 -0.166556 13.4954 0.0467149C14.7125 0.264622 15.8457 1.23361 15.6359 2.90269L15.2954 4.9334H18.2426C18.7742 4.9334 19.2685 5.16985 19.6043 5.57785C19.94 5.98584 20.0706 6.51902 19.9633 7.03365L18.0141 16.4732C17.8602 17.215 17.198 17.7528 16.4379 17.7528L16.4426 17.7436Z",
    className: "fill-selector",
    fill: "#48C44D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.25c9e8752ef90910620d3d080d613180.svg";
export { ForwardRef as ReactComponent };